export function formatError(error: unknown): string {
  const friendlyNameForStatus = (status: number) => {
    switch (status) {
      case 400:
        return 'Invalid request data';
      case 401:
        return 'Please sign in again';
      case 403:
        return "You don't have permission to access this";
      case 404:
        return "The requested resource couldn't be found";
      case 500:
        return 'Something went wrong on our end';
      default:
        return 'An error occurred';
    }
  };

  if (error instanceof Error) {
    if ('response' in error) {
      const response = (error as { response: unknown }).response as object;
      if ('errors' in response) {
        const errors = (response as { errors: { message: string }[] }).errors;
        return errors?.[0]?.message || 'Unknown error';
      }
      if ('status' in response) {
        const status = (response as { status: number }).status;
        return friendlyNameForStatus(status);
      }
    }
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return JSON.stringify(error);
}
